import { render, staticRenderFns } from "./JTMSDashboardOverview.vue?vue&type=template&id=127a4ed4&scoped=true&"
import script from "./JTMSDashboardOverview.vue?vue&type=script&lang=ts&"
export * from "./JTMSDashboardOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a4ed4",
  null
  
)

export default component.exports